function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// Check for MutationObserver support
window.MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

function getSourceSets(imageUrl) {
  var resolutions = [50, 180, 360, 480, 720, 900, 1080, 1296, 1512, 1728, 2048];
  var re = /(_[0-9]*x[0-9]*)?.(jpg|png|gif)/;
  var srcsets = [];

  for (var i = 0; i < resolutions.length; i++) {
    var res = resolutions[i];
    var url = imageUrl.replace(re, "_" + res + "x.$2");
    srcsets.push(url + " " + res + "w");
  }

  return srcsets.join(",");
}

var observer = new MutationObserver(function(mutations) {
  for (var idx = 0; idx < mutations.length; idx++) {
    var mutation = mutations[idx];

    if (mutation.attributeName == "src") {
      var img = mutation.target;
      img.removeAttribute("srcset");
      img.removeAttribute("data-srcset");
      img.removeAttribute("data-src");
    }
  }
});

var config = { attributes: true };
var targets = document.getElementsByClassName("hs-lazyload");

for (var i = 0; i < targets.length; i++) {
  observer.observe(targets[i], config);
}

document.addEventListener("lazybeforeunveil", function(e) {
  setTimeout(function() {
    e.target.style.minWidth = null;
  }, 500);
}, { once: true });

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) => 
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      // buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

     if (window.innerWidth < 750) {
      const button = this.querySelector('button');

      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    /*poster.addEventListener('click', this.loadContent.bind(this));*/
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      } 
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();


    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(false, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    //console.log("current: ", this);
    if (!this.currentVariant) {      
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {      
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }

    window.currentVariant = this.currentVariant; // 🔹 global
  }

  updateOptions() {
    const selectValues = Array.from(this.querySelectorAll('select'), select => select.value);

    /* const swatchValues = Array.from(
      document.querySelectorAll('.swatch-meta-container.selected'),
      el => el.getAttribute('value')
    ).filter(Boolean); */

    this.options = [...selectValues];
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      //console.log('see options', this.options.length, variant.options.length);
      if (this.options.length !== variant.options.length) {
        const offset = variant.options.length - this.options.length;
        return this.options.every((opt, index) => opt === variant.options[index + offset]);
      } else {
        return this.options.every((opt, index) => opt === variant.options[index]);
      }
    });
    //console.log('see results', this.options, this.currentVariant);
    /* console.log('see getvariant', this.getVariantData());
    console.log('see variants', this.options, this.currentVariant); */
    /* this.currentVariant = this.getVariantData().find((variant) => {
      if(variant.options.length == this.options.length) {
        return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
      } else {
        const filteredArray = variant.options.filter(item => !isNaN(item));
        console.log("see here", filteredArray);
        return !filteredArray
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);

      }
      
    }); */
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  /* updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    console.log('updating url');
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  } */
 updateURL() {
  if (!this.currentVariant || this.dataset.updateUrl === 'false') return;

  const cur = new URL(window.location.href);
  const variantId = String(this.currentVariant.id);

  // Path base del producto desde data-url (suele ser /products/{handle})
  let productPath = '';
  try {
    const u = new URL(this.dataset.url, window.location.origin);
    productPath = u.pathname.replace(/\/+$/, '');
  } catch {
    productPath = cur.pathname.replace(/\/+$/, '');
  }

  // Si hay contexto de colección en la URL actual, lo preservamos.
  // También permitimos forzar el handle vía data-collection-handle en el picker.
  const existingMatch = cur.pathname.match(/^\/collections\/([^/]+)\/products\/[^/]+/);
  const withinHandle = this.dataset.collectionHandle || (existingMatch && existingMatch[1]) || null;

  // Extrae el handle del producto de productPath (/products/{handle}[...])
  let productHandle = productPath.split('/products/')[1] || '';
  productHandle = productHandle.split('/')[0]; // por si hubiera segmentos extra

  // Construye el pathname final
  if (withinHandle && productHandle) {
    cur.pathname = `/collections/${withinHandle}/products/${productHandle}`;
  } else {
    cur.pathname = productPath || cur.pathname;
  }

  // Actualiza solo el parámetro variant, preservando el resto
  if (variantId) {
    cur.searchParams.set('variant', variantId);
  } else {
    cur.searchParams.delete('variant');
  }

  window.history.replaceState({}, '', cur.toString());
}


  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');      
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => variant.options.includes(this.querySelector(':checked').value)
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    let optionsCount = this.variantData[0].options;

    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      let realIndex = index;
      if(optionsCount.length > inputWrappers.length) {
        realIndex = index + 1;
      }
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked')?.value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${realIndex}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${realIndex + 1}`]);        
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    
    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        //console.log(responseText)
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;        
        
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        let destination = null;
        
        if(sectionId == 'cart-drawer') {
          destination = document.querySelector('.upsell_price');                  
        } else {
          destination = window.innerWidth < 992 ? document.getElementById(`price-${this.dataset.section}`) : document.getElementById(`price-${this.dataset.section}-desktop`);          
        }
        let source = null;
        if(sectionId == 'cart-drawer') {
          source = document.querySelector('.upsell_price');
        } else {
          source = html.getElementById(
            `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}-desktop`
          );          
        }
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
        
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        let price = null;
        if(sectionId == 'cart-drawer') {
          price = document.querySelector('.upsell_price');
        } else {
          price = window.innerWidth < 992 ? document.getElementById(`price-${this.dataset.section}`) : document.getElementById(`price-${this.dataset.section}-desktop`);
        }

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        let addButtonUpdated = null;  
        if(sectionId == 'cart-drawer') {
          addButtonUpdated = document.getElementById(`ProductSubmitButton-${sectionId}`);         
        } else {
          addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        }
        
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );
        
        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .catch(error => console.log("No se pudo renderizar la informacion", error))
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');    
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {      
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {      
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if(this.id === 'variant-selects-cart-drawer') {
      const selectedId = this.parentElement.parentElement.querySelector('input[name="id"]').value;
      let isAvailable = this.variantData.find(variant => variant.id == selectedId);
      if(isAvailable) {
        addButton.removeAttribute('disabled');
      }
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    //const price = document.getElementById(`price-${this.dataset.section}`);
    const price = window.innerWidth < 992 ? document.getElementById(`price-${this.dataset.section}`) : document.getElementById(`price-${this.dataset.section}-desktop`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    const upsell_id = this.getAttribute('data-product-id');
    if(upsell_id) {
      this.variantData = this.variantData || JSON.parse(document.querySelector(`#upsell_td-${upsell_id} [type="application/json"]`).textContent);
    } else {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    }   
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
        if(input.closest(".new-style .show-bar")) {
          input.closest(".new-style .show-bar").classList.remove('not-available');
        }
      } else {
        input.classList.add('disabled');
        if(input.closest(".new-style .show-bar")) {
          input.closest(".new-style .show-bar").classList.add('not-available');
        }
      }
    });
  }

  updateOptions() {
    // Valores de radios dentro de fieldsets
    const fieldsetOptions = Array.from(this.querySelectorAll('fieldset')).map(fieldset => {
      return Array.from(fieldset.querySelectorAll('input')).find(input => input.checked)?.value;
    }).filter(Boolean); // quita undefined

    // Valores de swatches visuales con atributo name
    /* const swatchOptions = Array.from(
      document.querySelectorAll('.swatch-meta-container.selected'),
      el => el.getAttribute('value')
    ).filter(Boolean); */

    // Combina ambos
    this.options = [...fieldsetOptions];
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          /*if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }*/

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// window.addEventListener('click', (e) => {
//   console.log('target', e.target)
// })

const variantKey = 'accordionABTest';
const viewSentKey = 'abTestViewSent';
let variant = sessionStorage.getItem(variantKey);
let viewSent = sessionStorage.getItem(viewSentKey);

// Si no hay variante guardada en la sesión, se elige una al azar
if (!variant) {
  variant = Math.random() < 0.5 ? 'A' : 'B';
  sessionStorage.setItem(variantKey, variant);
}

document.addEventListener('DOMContentLoaded', function() {
  const elementA = document.getElementById('tabs');
  const elementB = document.getElementById('openTabs');
  const variantLabel = variant === 'A' ? 'Accordions' : 'Open Tabs';

  if (elementA && elementB) {
    if (variant === 'A') {
      elementA.style.display = 'block';
      elementB.style.display = 'none';
      //console.log('Showing Variant A (Accordions)');
    } else {
      elementA.style.display = 'none';
      elementB.style.display = 'block';
      //console.log('Showing Variant B (Open Tabs)');
    }
  }

  if(!viewSent) {
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'ab_test_view',
      variant: variantLabel
    });
    sessionStorage.setItem(viewSentKey, 'true');
  }

  // Registrar clics en botones CTA
  let tabsClick = document.querySelectorAll('.pdp-accordion.tab-label');
  tabsClick && tabsClick.forEach(button => {
    button.addEventListener('click', () => {
      dataLayer.push({
        event: 'ab_test_click',
        variant: variantLabel,
        button_id: `Accordion ${button.id || 'tabs'}`
      });
    });
  });

  if(variant == 'B') {
    let sectionTabs = document.querySelector('.openTabs')
    /* sectionTabs && sectionTabs.addEventListener('click', () => {
      dataLayer.push({
        event: 'ab_test_click',
        variant: variantLabel,
        button_id: 'opentab Open Section'
      });
    }); */

    if (sectionTabs) {
      /* Mouse enter to element */
      sectionTabs.addEventListener('mouseenter', () => {
        dataLayer.push({
          event: 'ab_test_hover',
          variant: variantLabel,
          section_id: 'openTabs Section'
        });
      });

      /* Visible Element on viewport */
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              event: 'ab_test_viewed',
              variant: variantLabel,
              section_id: 'openTabs Section'
            });

            // Solo queremos registrar esto una vez
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.5 // al menos el 50% del elemento debe ser visible
      });

      observer.observe(sectionTabs);

    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const imagesWebp = document.querySelectorAll("img:not(.okeReviews-mediaStrip img):not(.collabs-page__main img):not(.gf_column img)");

  imagesWebp.forEach(img => {
    const parentPicture = img.closest('picture') ? img.closest('picture') : false;
    const src = img.getAttribute("src");
    const srcset = img.getAttribute('srcset');
    const sizes = img.getAttribute('sizes');
    
    if (src && !parentPicture) {
      const picture = document.createElement('picture');
      picture.classList.add('responsive-picture');
      const sourceWebp = document.createElement('source');
      const sourceOriginal = document.createElement('source');

      // Check if the image is PNG or JPG/JPEG
      const isPng = src.endsWith('.png') || src.includes('.png?');
      const isJpg = src.endsWith('.jpg') || src.includes('.jpg?') || src.endsWith('.jpeg') || src.includes('.jpeg?');

      if (isPng || isJpg) {
        // Add .webp versionbase
        const cleanedSrc = src.replace(/\?.*$/, '');

        // Crea los elementos <source> para WebP y JPEG
        const webpSrc = cleanedSrc + ".webp" + src.match(/\?.*$/) || "";
        //sourceWebp.srcset = src.replace(/(\.\w+)(\?.*)?$/, '.webp$2');
        if(srcset) {
          sourceWebp.srcset = img.getAttribute('srcset');
        }
        if(sizes) {
          sourceWebp.sizes = img.getAttribute('sizes');
        }
        sourceWebp.type = 'image/webp';
        sourceWebp.src = src;

        // Add original version (PNG or JPG)
        if(srcset) {
          sourceOriginal.srcset = img.getAttribute('srcset');
        }
        if(sizes) {
          sourceOriginal.sizes = img.getAttribute('sizes');
        }
        sourceOriginal.type = isPng ? 'image/png' : 'image/jpeg';
        sourceOriginal.src = src;

        // Append sources and original img to picture element
        picture.appendChild(sourceWebp);
        picture.appendChild(sourceOriginal);
        img.replaceWith(picture);
        picture.appendChild(img);
      }
    }
  });

  // Klaviyo popup trigger
  const klaviyoPopupButtonTrigger = document.querySelector('#kvy-popup-trigger');
  if (klaviyoPopupButtonTrigger) {
    klaviyoPopupButtonTrigger.addEventListener('click', () => {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', 'U32aSe']);
    });
  }

  /*if (window.location.pathname === "/challenge") {
    const form = document.querySelector("#captcha_form");
    console.log("see form", form);
    form.addEventListener("submit", function (event) {
      event.preventDefault();  // Evitar el envío del formulario de inmediato
      const urlParams = new URLSearchParams(window.location.search);
      const returnPath = urlParams.get("return_path");
      
      if (returnPath && returnPath.includes("gempages")) {
            // Cambiar la acción del formulario si es necesario
            form.action = '/';  // Cambia '/nueva-ruta' por la ruta que deseas

            // Luego enviar el formulario
            form.submit(); 
      }
    });
  }*/

  /* Articles Style from GemPages */ 
  const currentUrl = window.location.pathname;
  const gempagesPosts = document.querySelectorAll('.gryffeditor');
  const includeRoutes = [
    '/blogs/news/crotch-gussets-101',
  ];
  
  if (includeRoutes.includes(currentUrl)) {
    if (gempagesPosts) {
      const link = document.createElement('link');
      link.href = '//dovetailworkwear.com/cdn/shop/t/303/assets/section-blog-post.css?v=53725368954404859051735842703';
      link.rel = 'stylesheet';
      link.type = 'text/css';
      link.media = 'all';
      document.head.appendChild(link);

      gempagesPosts.forEach((gem) => {
        gem.classList.add('article-template');
        const elementStyleText = gem.querySelectorAll('.element-wrap');
        if(elementStyleText) {
          elementStyleText.forEach((text_element, index) => {
            if(index > 0) {
              text_element.classList.add('page-width');
              text_element.classList.add('page-width--narrow');
              text_element.classList.add('rte');
              text_element.classList.add('scroll-trigger');
              text_element.classList.add('animate--slide-in');
            }
          })
        }
      });

    }
  } else {
    //console.log("entra aqui", gempagesPosts);
    gempagesPosts.forEach((gem) => {
      gem.classList.add('show');
      gem.classList.add('page-width');
    })
    
  }

   /* Articles Style from GemPages */ 

  const isMobile = window.matchMedia("(max-width: 767px)").matches;
  const hero = document.querySelectorAll(".hero-banner .hero-image-banner");
  if (hero && hero.length > 0) {
    hero.forEach((image) => {
      const isMobileImage = image.classList.contains("mobile_only");
      const isDesktopImage = image.classList.contains("desktop_only");
      //console.log('see here images viewport', isMobileImage, isDesktopImage);
      
      if(
        (isMobile && isMobileImage) ||
        (!isMobile && isDesktopImage) ||
        (!isMobileImage && !isDesktopImage)
      ) {
        const preload = document.createElement("link");
        preload.rel = "preload";
        preload.as = "image";
        preload.href = image.currentSrc;
        preload.type = "image/jpeg";
        //preload.setAttribute("imagesrcset", image.dataset.srcset);
        //preload.setAttribute("imagesizes", image.dataset.sizes);
        //preload.fetchPriority = "high";
        document.head.appendChild(preload);

        //console.log('see this section', image.currentSrc, preload.href);
      }
    })
  }
});


document.addEventListener("DOMContentLoaded", function() {
  if (window.posthog) {
    /* Desktop */
    document.querySelectorAll(".header header-menu a").forEach(link => {
      link.addEventListener("click", function(e) {
        const clickedText = link.textContent.trim();

        let topLevel = "";
        const details = link.closest("details.mega-menu");
        if (details) {
          const summary = details.querySelector("summary a, summary span");
          if (summary) {
            topLevel = summary.textContent.trim();
          }
        }

        let secondary = "";
        if (link.classList.contains("mega-menu__link--level-2")) {
          secondary = clickedText;
        } else {
          // buscar el padre nivel 2 más cercano
          const parentLevel2 = link.closest("ul").previousElementSibling;
          if (parentLevel2 && parentLevel2.classList.contains("mega-menu__link--level-2")) {
            secondary = parentLevel2.textContent.trim();
          }
        }

        let tertiary = "";
        if (
          !link.classList.contains("mega-menu__link--level-2") &&
          secondary !== clickedText
        ) {
          tertiary = clickedText;
        }

        const levels = [topLevel, secondary, tertiary].filter(Boolean).join(" > ");

        console.log("👉 Nav Menu Click detectado:", levels);

        if (window.posthog) {
          window.posthog.capture("Nav Menu Click", {
            hierarchy: levels,
            clicked: clickedText,
            url: link.getAttribute("href")
          });
        }
      });
    });

    /* Mobile */
    const mobileNav = document.querySelector("#menu-drawer");
    if (!mobileNav) {
      console.log("❌ No encontré el menú drawer");
      return;
    }

    mobileNav.querySelectorAll("a").forEach(link => {
      link.addEventListener("click", function(e) {
        const clickedText = link.textContent.trim();

        let topLevel = "";
        let secondary = "";
        let tertiary = "";

        if (link.classList.contains("first_link")) {
          topLevel = clickedText;
        } else if (link.classList.contains("second_link")) {
          const parentFirst = link.closest(".menu-drawer__inner-submenu")
            ?.previousElementSibling?.querySelector(".first_link");
          if (parentFirst) topLevel = parentFirst.textContent.trim();
          secondary = clickedText;
        } else {
          const parentSecond = link.closest(".menu-drawer__submenu")
            ?.previousElementSibling;
          if (parentSecond && parentSecond.classList.contains("second_link")) {
            secondary = parentSecond.textContent.trim();
          }
          const parentFirst = link.closest(".menu-drawer__inner-submenu")
            ?.previousElementSibling?.querySelector(".first_link");
          if (parentFirst) topLevel = parentFirst.textContent.trim();
          tertiary = clickedText;
        }

        const levels = [topLevel, secondary, tertiary].filter(Boolean).join(" > ");

        console.log("👉 Mobile Nav Click detectado:", levels);

        if (window.posthog) {
          window.posthog.capture("Mobile Nav Menu Click", {
            hierarchy: levels,
            clicked: clickedText,
            url: link.getAttribute("href")
          });
        }
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  const regex = /hotswap™?|hotswap/gi;

  function processHotSwap(node) {
    node.innerHTML = node.innerHTML.replace(regex, function(match) {
      if (/™/i.test(match)) {
        return '<span class="hot-word">HOT</span><span class="swap-word">SWAP</span><sup>™</sup>';
      } else {
        return '<span class="hot-word">HOT</span><span class="swap-word">SWAP</span>';
      }
    });
  }

  document.querySelectorAll(".snize-title").forEach(processHotSwap);
  document.querySelectorAll(".snize-ac-results-list .snize-category .snize-view-link").forEach(processHotSwap);

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) {
          if (node.matches && node.matches(".snize-title")) {
            processHotSwap(node);
          } 
          if (node.matches && node.matches(".snize-ac-results-list .snize-category .snize-view-link")) { 
            processHotSwap(node);
          }
          node.querySelectorAll?.(".snize-title").forEach(processHotSwap);
          node.querySelectorAll?.(".snize-ac-results-list .snize-category .snize-view-link").forEach(processHotSwap);
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});